module.exports = __webpack_public_path__ + "img/text_decoration_capitals.f7f9443c.svg";